import ptBr from './ptBr.i18n'
import esCo from './esCo.i18n'
import enUs from './enUs.i18n'

const mensagens: Record<string, Record<string, any>> = {
  'pt-BR': ptBr,
  'es': esCo,
  'en-US': enUs
}

export default mensagens
